import { Mail, MailOpen, MailWarning } from 'lucide-react';

/** Same icons as Building Documents mail column (sent / opened / failed / not sent). */
export default function DocumentMailStatus({
  status,
  className = 'w-4 h-4',
  showLabel = false,
}) {
  const key = String(status || '').toLowerCase();
  if (key === 'opened') {
    return (
      <span className="inline-flex items-center gap-1" title="Opened by recipient">
        <MailOpen className={`${className} text-emerald-700`} aria-label="Opened" />
        {showLabel ? <span className="text-xs text-emerald-800">Opened</span> : null}
      </span>
    );
  }
  if (key === 'failed') {
    return (
      <span className="inline-flex items-center gap-1" title="Send failed — click to resend">
        <MailWarning className={`${className} text-red-600`} aria-label="Send failed" />
        {showLabel ? <span className="text-xs text-red-700">Failed</span> : null}
      </span>
    );
  }
  if (key === 'sent') {
    return (
      <span className="inline-flex items-center gap-1" title="Sent — waiting for open">
        <Mail className={`${className} text-slate-700`} aria-label="Sent" />
        {showLabel ? <span className="text-xs text-slate-700">Sent</span> : null}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1" title="Not sent — click to send">
      <Mail className={`${className} text-gray-300`} aria-label="Not sent" />
      {showLabel ? <span className="text-xs text-gray-400">Not sent</span> : null}
    </span>
  );
}

export function mailNeedsSend(status) {
  const key = String(status || '').toLowerCase();
  return !key || key === 'failed';
}
